import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { PAYMENT_GET_API, PAYMENT_POST_ORDER_API } from "../app/constants";
import { BASE_URL } from "..";
import useHomeStore from "./ZustandStore/useHomeStore";

const PaymentSection = () => {
  const token = localStorage.getItem("accessToken");

  const [activeTab, setActiveTab] = useState(0);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState("");

  // Fetch Payment Methods Data
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) throw new Error("Access token not found.");

        const response = await axios.get(`${BASE_URL}${PAYMENT_GET_API}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (response.data && response.data.code === 1) {
          const fetchedData = response.data.data.map((item) => ({
            id: item.id,
            method: item.paymentOption,
            icon: "bi bi-credit-card",
            iconColor: "#2ecc71",
          }));
          setPaymentMethods(fetchedData);
        } else {
          throw new Error(response.data.message || "Failed to fetch data.");
        }
      } catch (error) {
        setError(error.message || "Error fetching payment methods.");
        console.error(error);
      }
    };

    fetchPaymentMethods();
  }, []);

  const postPayment = async (id) => {
    const payload = {
      orderId: Number(sessionStorage.getItem("orderId")),
      paymentMethodId: id,
    };

    try {
      const response = await axios.post(
        `${BASE_URL}${PAYMENT_POST_ORDER_API}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        console.log(response.data.data);
      } else {
        throw new Error(response.data.message || "Failed to fetch data.");
      }
    } catch (error) {
      setError(error.message || "Error fetching charges.");
    }
  };

  return (
    <section className="payment py-40 bg-light">
      <div className="container container-lg px-lg-5">
        <div className="row gy-4">
          <div className="col-xl-9 col-lg-8 pb-10 d-flex flex-column-reverse flex-lg-row justify-content-lg-between">
            <div className="flex-wrap order-2 order-lg-2">
              <h4 className="fw-medium">Select Payment Method</h4>
              <div className="d-flex flex-align-start">
                {paymentMethods.map((item, index) => (
                  <div
                    key={index}
                    className={`box-shadow-lg text-black payment-upper cursor-pointer flex-center flex-column fw-bold ${
                      activeTab === index ? "bg-white " : "bg-light "
                    }`}
                    style={{
                      borderBottom:
                        activeTab === index
                          ? "8px solid #fff"
                          : "8px solid #e9eaeb",
                      minWidth: "10.3rem",
                      minHeight: "10.3rem",
                      transition: "all 0.3s ease-in-out",
                    }}
                    onClick={() => setActiveTab(index)}
                  >
                    <i
                      className={`${item.icon} text-4xl`}
                      style={{ color: item.iconColor }}
                    ></i>
                    <p className="text-nowrap text-sm">{item.method}</p>
                  </div>
                ))}
              </div>
              <div
                className="row justify-content-center"
                style={{ maxWidth: "40rem", marginInline: "0.01rem" }}
              >
                {paymentMethods.map((item, index) => (
                  <div
                    key={index}
                    className={`col-xl-9 col-lg-8 py-40 w-100 h-100 bg-white ${
                      activeTab === index ? "d-block" : "d-none"
                    }`}
                    style={{
                      minWidth: "97.8%",
                      transition: "transform 0.3s ease-in-out",
                      transform:
                        activeTab === index ? "scale(1)" : "scale(0.95)",
                    }}
                  >
                    <h5 className="mb-3">{item.method}</h5>
                    <div>
                      <Link
                        onClick={async () => {
                          await postPayment(item.id);
                        }}
                        // to="/checkout"
                        className="btn btn-main mt-40 py-18 rounded-0"
                      >
                        Confirm Order
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 h-100 position-sticky top-0 bg-white box-shadow-md">
            <div className="cart-sidebar py-20 px-10">
              <div className="mt-32 p-0">
                <div className="mb-32 flex-between gap-8">
                  <span className="text-gray-900 text-xl fw-bold font-heading-two">
                    Order Summary
                  </span>
                </div>
                <div className="mb-32 flex-between gap-8">
                  <span className="font-heading-two text-muted text-sm">
                    Subtotal
                  </span>
                  <span className="text-gray-900 text-sm">Rs. 252</span>
                </div>
                <div className="mb-32 flex-between gap-8">
                  <span className="text-muted font-heading-two text-sm">
                    Shipping fee
                  </span>
                  <span className="text-gray-900 text-sm">Rs. 100</span>
                </div>
              </div>
              <div className="mt-24">
                <div className="flex-between gap-8">
                  <span className="text-gray-900 text-xl">Total Amount</span>
                  <span className="text-main text-xl">Rs. 542</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {error && <p className="text-danger mt-3">{error}</p>}
    </section>
  );
};

export default PaymentSection;
